/* @flow */
import * as React from 'react';
import cx from 'classnames';

import Text from 'components/Text.jsx';

import type { TextBadgeColor, TextBadgeTextColor } from './';

import './styles/TextBadge.scss';

type Props = {
  color: TextBadgeColor,
  textSize: 'xsmall' | 'xxxxsmall',
  textColor: TextBadgeTextColor,
  textWeight: 'normal' | 'semibold',
  children: any,
};

class TextBadge extends React.PureComponent<Props> {
  static defaultProps = {
    color: 'polar-bear',
    textColor: 'thunder',
    textWeight: 'semibold',
    textSize: 'xsmall',
  };

  render() {
    const { color, textColor, textWeight, textSize, children } = this.props;

    return (
      <Text
        color={textColor}
        weight={textWeight}
        size={textSize}
        className={cx('TextBadge', `TextBadge--${color}`, `TextBadge--${textSize}`)}
        element="div">
        {children}
      </Text>
    );
  }
}

export default TextBadge;
